import { render, staticRenderFns } from "./DownloadMessageModal.vue?vue&type=template&id=3d187e39&"
import script from "./DownloadMessageModal.vue?vue&type=script&lang=ts&"
export * from "./DownloadMessageModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports